import colors from '@rategravity/frontend/theme/colors';
import Immutable from 'immutable';
import lightBaseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

export const lightGray = '#EFF3F5';
export const gray = '#8FA8B4';
export const red = '#FF7A7A';
export const green = '#00B173';

export const muiTheme = getMuiTheme(
  Immutable.fromJS(lightBaseTheme)
    .mergeDeep(
      Immutable.fromJS({
        fontFamily: 'Cera-Regular, Graphik-Regular',
        palette: {
          primary1Color: colors.primary,
          primary2Color: colors.tertiary,
          primary3Color: colors.white,
          accent1Color: colors.secondary,
          accent2Color: colors.tertiary,
          accent3Color: colors.quarternary,
          borderColor: colors.quarternary,
          textColor: colors.primary
        }
      })
    )
    .toJS()
);



// WEBPACK FOOTER //
// ./src/shared/theme.js